<div class="flex items-center w-full space-x-2">
  <div class="relative flex-grow">
    <input #searchInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" placeholder="Search..."
      data-cy="page-dashboard-input-search"
      class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400" />
    @if (searchTerm) {
    <button (click)="onClear()"
      data-cy="page-dashboard-button-clearSearch"
      class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
      <span class="material-symbols-outlined">close</span>
    </button>
    }
  </div>
  <button (click)="onSearch()" data-cy="page-dashboard-button-search" class="btn-primary">
    Search
  </button>
</div>